// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ROyf","footer":"styles_footer__2I14-","passCodeTooltip":"styles_passCodeTooltip__Y8s_W"};